export const PACK_ROOT = "/assets/game-pack-v01";

export const AssetKeys = {
  terrain: {
    dirt: "terrain.dirt",
    stone: "terrain.stone",
    grass: "terrain.grass",
    mud: "terrain.mud",
    swamp: "terrain.swamp",
    roots: "terrain.roots",
    water: "terrain.water",
    fog: "terrain.fog",
    swampOverlay: "terrain.swampOverlay",
    riverOverlay: "terrain.riverOverlay",
    stonesOverlay: "terrain.stonesOverlay"
  },
  obstacle: {
    treeDead: "obstacle.treeDead",
    treeTwisted: "obstacle.treeTwisted",
    rootWall: "obstacle.rootWall",
    rootCurve: "obstacle.rootCurve",
    log: "obstacle.log",
    rockHuge: "obstacle.rockHuge",
    rockCluster: "obstacle.rockCluster",
    ruin: "obstacle.ruin",
    bush: "obstacle.bush",
    thorn: "obstacle.thorn",
    stump: "obstacle.stump",
    toxic: "obstacle.toxic"
  },
  wolf: {
    idle: "wolf.idle",
    shadow: "wolf.shadow",
    run: "wolf.run",
    runUpV2: "wolf.runUpV2",
    runLeft: "wolf.runLeft",
    runRight: "wolf.runRight",
    champion: "wolf.champion",
    injured: "wolf.injured"
  },
  ghost: [
    "ghost.hunter",
    "ghost.left",
    "ghost.right",
    "ghost.predictive",
    "ghost.erratic",
    "ghost.shadow",
    "ghost.leader"
  ],
  vfx: {
    ghostTrail: "vfx.ghostTrail",
    ghostAura: "vfx.ghostAura",
    musicWave: "vfx.musicWave",
    dangerBorder: "vfx.dangerBorder",
    energy: "vfx.energy",
    championExplosion: "vfx.championExplosion",
    logo: "vfx.logo",
    aimIsotypeSource: "vfx.aimIsotypeSource",
    aimBooster: "vfx.aimBooster",
    wolfGlow: "vfx.wolfGlow"
  },
  deco: {
    skull: "deco.skull",
    puddle: "deco.puddle",
    bones: "deco.bones",
    dust: "deco.dust",
    mark: "deco.mark",
    mushrooms: "deco.mushrooms",
    cracks: "deco.cracks",
    fireflies: "deco.fireflies",
    grass: "deco.grass",
    moss: "deco.moss"
  }
} as const;

export const preloadAssets: Array<[string, string]> = [
  [AssetKeys.terrain.dirt, "01_terrain_base_tiles/terrain_ground_wet_dark_01.png"],
  [AssetKeys.terrain.stone, "01_terrain_base_tiles/terrain_stone_path_01.png"],
  [AssetKeys.terrain.grass, "01_terrain_base_tiles/terrain_moss_dense_01.png"],
  [AssetKeys.terrain.mud, "01_terrain_base_tiles/terrain_mud_dark_01.png"],
  [AssetKeys.terrain.swamp, "01_terrain_base_tiles/terrain_swamp_ground_01.png"],
  [AssetKeys.terrain.roots, "01_terrain_base_tiles/terrain_roots_ground_01.png"],
  [AssetKeys.terrain.water, "02_special_terrain_overlays/terrain_river_curve_01.png"],
  [AssetKeys.terrain.fog, "02_special_terrain_overlays/terrain_low_fog_01.png"],
  [AssetKeys.terrain.swampOverlay, "02_special_terrain_overlays/terrain_swamp_large_slow_01.png"],
  [AssetKeys.terrain.riverOverlay, "02_special_terrain_overlays/terrain_river_curve_01.png"],
  [AssetKeys.terrain.stonesOverlay, "02_special_terrain_overlays/terrain_stepping_stones_01.png"],
  [AssetKeys.obstacle.treeDead, "03_large_obstacles_labyrinth/obstacle_tree_dead_tall_01.png"],
  [AssetKeys.obstacle.treeTwisted, "03_large_obstacles_labyrinth/obstacle_tree_twisted_01.png"],
  [AssetKeys.obstacle.rootWall, "03_large_obstacles_labyrinth/obstacle_root_wall_01.png"],
  [AssetKeys.obstacle.rootCurve, "03_large_obstacles_labyrinth/obstacle_root_giant_curve_01.png"],
  [AssetKeys.obstacle.log, "03_large_obstacles_labyrinth/obstacle_log_giant_horizontal_01.png"],
  [AssetKeys.obstacle.rockHuge, "03_large_obstacles_labyrinth/obstacle_rock_huge_moss_01.png"],
  [AssetKeys.obstacle.rockCluster, "04_medium_obstacles/obstacle_rock_cluster_01.png"],
  [AssetKeys.obstacle.ruin, "03_large_obstacles_labyrinth/obstacle_ruin_broken_large_01.png"],
  [AssetKeys.obstacle.bush, "04_medium_obstacles/obstacle_bush_dense_01.png"],
  [AssetKeys.obstacle.thorn, "04_medium_obstacles/obstacle_thorn_bush_01.png"],
  [AssetKeys.obstacle.stump, "04_medium_obstacles/obstacle_stump_old_01.png"],
  [AssetKeys.obstacle.toxic, "04_medium_obstacles/obstacle_toxic_plant_01.png"],
  [AssetKeys.wolf.idle, "06_player_wolf/wolf_white_idle_up_01.png"],
  [AssetKeys.wolf.shadow, "06_player_wolf/wolf_shadow_01.png"],
  [AssetKeys.wolf.injured, "06_player_wolf/wolf_white_injured_01.png"],
  [AssetKeys.ghost[0], "07_enemy_ghosts/enemy_ghost_hunter_01.png"],
  [AssetKeys.ghost[1], "07_enemy_ghosts/enemy_ghost_flanker_left_01.png"],
  [AssetKeys.ghost[2], "07_enemy_ghosts/enemy_ghost_flanker_right_01.png"],
  [AssetKeys.ghost[3], "07_enemy_ghosts/enemy_ghost_predictive_01.png"],
  [AssetKeys.ghost[4], "07_enemy_ghosts/enemy_ghost_erratic_01.png"],
  [AssetKeys.ghost[5], "07_enemy_ghosts/enemy_ghost_shadow_01.png"],
  [AssetKeys.ghost[6], "07_enemy_ghosts/enemy_ghost_leader_grotesque_01.png"],
  [AssetKeys.vfx.ghostTrail, "07_enemy_ghosts/vfx_spectral_trail_01.png"],
  [AssetKeys.vfx.ghostAura, "07_enemy_ghosts/vfx_ghost_aura_01.png"],
  [AssetKeys.vfx.musicWave, "08_ui_vfx_music/vfx_music_wave_green_01.png"],
  [AssetKeys.vfx.dangerBorder, "08_ui_vfx_music/ui_danger_red_border_01.png"],
  [AssetKeys.vfx.energy, "08_ui_vfx_music/pickup_energy_crystal_01.png"],
  [AssetKeys.vfx.championExplosion, "08_ui_vfx_music/vfx_champion_explosion_01.png"],
  [AssetKeys.vfx.logo, "08_ui_vfx_music/logo_aim_wind_x_hud_01.png"],
  [AssetKeys.vfx.aimIsotypeSource, "09_branding_references/aim_wind_x_isotype_official_source.png"],
  [AssetKeys.deco.skull, "05_decorative_gameplay_props/deco_animal_skull_01.png"],
  [AssetKeys.deco.puddle, "05_decorative_gameplay_props/deco_black_puddle_01.png"],
  [AssetKeys.deco.bones, "05_decorative_gameplay_props/deco_broken_bones_01.png"],
  [AssetKeys.deco.dust, "05_decorative_gameplay_props/deco_dust_particles_01.png"],
  [AssetKeys.deco.mark, "05_decorative_gameplay_props/deco_energy_mark_01.png"],
  [AssetKeys.deco.mushrooms, "05_decorative_gameplay_props/deco_glowing_mushrooms_01.png"],
  [AssetKeys.deco.cracks, "05_decorative_gameplay_props/deco_green_cracks_01.png"],
  [AssetKeys.deco.fireflies, "05_decorative_gameplay_props/deco_green_fireflies_01.png"],
  [AssetKeys.deco.grass, "05_decorative_gameplay_props/deco_low_grass_01.png"],
  [AssetKeys.deco.moss, "05_decorative_gameplay_props/deco_luminous_moss_01.png"]
];

export const spriteSheets = [
  [AssetKeys.wolf.run, "06_player_wolf/wolf_white_run_up_sheet.png"],
  [AssetKeys.wolf.runLeft, "06_player_wolf/wolf_white_run_diag_left_sheet.png"],
  [AssetKeys.wolf.runRight, "06_player_wolf/wolf_white_run_diag_right_sheet.png"],
  [AssetKeys.wolf.champion, "06_player_wolf/wolf_white_champion_sheet.png"]
] as const;

export function assetUrl(path: string): string {
  return `${PACK_ROOT}/${path}`;
}
